import forEach from 'utils/DOM/forEach'

function innerHTML(selector: StringOrNodeSelector, value) {
  forEach(selector, node => {
    node.innerHTML = value
  })
}

export default innerHTML
